<template>
  <div class="container-sm my-4 d-flex justify-content-center">
    <Head title="Restablecer contraseña" />
    <div class="col-12 col-md-6">
      <div class="lpg-form ">
        <form method="post" @submit.prevent="form.post($route('password.update'))">
          <h1>Restablecer contraseña</h1>
          <h4 class="text-secondary">
            Ingresa una nueva contraseña
          </h4>
          <div v-if="Object.keys(errors).length > 0" class="my-4 alert alert-secondary">
            <ul class="my-0">
              <li v-for="(error, key) in errors" :key="key">
                {{ error }}
              </li>
            </ul>
          </div>

          <div class="my-4">
            <input
              v-model="form.password"
              type="password"
              placeholder="Contraseña nueva:"
              :class="['form-control form-control-lg', { 'lpg-error': errors.password }]"
            />
          </div>
          <div class="my-4">
            <input
              v-model="form.password_confirmation"
              type="password"
              placeholder="Confirmar contraseña nueva:"
              :class="['form-control form-control-lg', { 'lpg-error': errors.password }]"
            />
          </div>
          <div class="my-4">
            <button type="submit" class="btn btn-secondary mt-1" :disabled="form.processing">
              <span
                :class="{
                  'visually-hidden': !form.processing,
                  'spinner-border spinner-border-sm': form.processing,
                }"
                role="status"
                aria-hidden="true"
              ></span>
              Cambiar contraseña
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import { Head } from '@inertiajs/inertia-vue'

export default {
  name: 'RestablecerContrasena',
  layout: Layout,
  components: { Head },
  props: {
    errors: {
      type: Object,
      default: {},
    },
    email: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: this.email,
        password: '',
        password_confirmation: '',
        token: this.token,
      }),
    }
  },
}
</script>
